import type { Tag } from '@tribeplatform/gql-client/types'
import { useSpaceTags, useSortedTags } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'

import { SpreadFilterItems } from '../../components/SpreadFilterItems.js'

interface Props {
  value: string[]
  options: string[]
  onChange: (tagIds: string[]) => void
}
export const SpreadTagPicker = ({ value, options, onChange }: Props) => {
  const { data } = useSpaceTags({
    variables: { ids: options, limit: options.length },
    useInfiniteQueryOptions: {
      enabled: options.length > 0,
    },
  })
  const { nodes: tagOptions } = simplifyPaginatedResult<Tag>(data)

  const { sortedTags } = useSortedTags({
    tags: tagOptions,
    sortOrderTagIds: options,
  })

  return (
    <SpreadFilterItems
      options={options}
      value={value}
      onChange={onChange}
      isLoading={!data}
    >
      {selectedOption => (
        <span
          title={
            sortedTags.find(({ id }) => id === selectedOption)?.title ?? ''
          }
        >
          {sortedTags.find(({ id }) => id === selectedOption)?.title ?? ''}
        </span>
      )}
    </SpreadFilterItems>
  )
}
